import React, { useState, useEffect } from 'react';
import './treatments.css';
import { useNavigate } from 'react-router-dom';
// NO IMPORT NEEDED for public folder images

function Treatments() {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedTreatment, setSelectedTreatment] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Treatment categories
  const categories = [
    { id: 'all', name: 'All Treatments', icon: 'fas fa-spa' },
    { id: 'massage', name: 'Massage', icon: 'fas fa-hand-sparkles' },
    { id: 'therapy', name: 'Therapies', icon: 'fas fa-leaf' },
    { id: 'bath', name: 'Bath Treatments', icon: 'fas fa-bath' }
  ];

  // Your actual treatments list
  const treatments = [
    {
      id: 1,
      name: 'Ayurvedic Full Body Massage',
      category: 'massage',
      image: '/fullbody90.jpg',
      duration: '90 min',
      price: 10000,
      description: 'Traditional full-body Ayurvedic massage with warm herbal oils to balance doshas and promote deep relaxation.',
      longDescription: 'This traditional Ayurvedic treatment involves a thorough full-body massage using warm herbal oils selected based on your dosha. The therapist uses long strokes and gentle pressure to stimulate energy points, improve circulation, and release tension from muscles.',
      benefits: [
        'Deeply relaxes nervous system',
        'Improves blood circulation',
        'Removes metabolic toxins',
        'Strengthens immune system',
        'Promotes deep sleep'
      ]
    },
    {
      id: 2,
      name: 'Ayurvedic Full Body Massage',
      category: 'massage',
      image: '/fullbody60.webp',
      duration: '60 min',
      price: 8000,
      description: 'Complete full-body massage using traditional Ayurvedic techniques and warm medicated oils.',
      longDescription: 'A comprehensive full-body massage that focuses on the seven dhatus (tissues) and works on marma points to restore energy balance and promote overall wellness.',
      benefits: [
        'Relieves muscle tension',
        'Enhances joint mobility',
        'Boosts energy levels',
        'Improves skin texture',
        'Reduces stress'
      ]
    },
    {
      id: 3,
      name: 'Head, Neck & Shoulder Massage',
      category: 'massage',
      image: '/headneckshoulder.webp',
      duration: '60 min',
      price: 4500,
      description: 'Therapeutic massage focusing on upper body tension points for relief from headaches and stiffness.',
      longDescription: 'Specialized treatment targeting the upper body where most tension accumulates. Combines traditional techniques to release knots, improve blood flow to the head, and relieve digital eye strain.',
      benefits: [
        'Relieves tension headaches',
        'Reduces neck stiffness',
        'Improves posture',
        'Calms the mind',
        'Enhances mental clarity'
      ]
    },
    {
      id: 4,
      name: 'Sinus Relief Therapy',
      category: 'therapy',
      image: '/sinus.webp',
      duration: '45 min',
      price: 4500,
      description: 'Gentle facial massage and steam therapy to clear sinus congestion and promote easy breathing.',
      longDescription: 'Specialized treatment using gentle massage techniques on face, head, and neck combined with herbal steam inhalation to open nasal passages and provide relief from sinus congestion.',
      benefits: [
        'Clears nasal passages',
        'Reduces sinus pressure',
        'Eases headaches',
        'Improves breathing',
        'Relieves allergy symptoms'
      ]
    },
    {
      id: 5,
      name: 'Stress Relief Therapy',
      category: 'therapy',
      image: '/stress relief.webp',
      duration: '45 min',
      price: 4500,
      description: 'Calming treatment combining gentle massage and marma point stimulation to reduce anxiety and stress.',
      longDescription: 'A gentle, nurturing treatment designed specifically to calm an overactive mind. Combines light massage with stimulation of specific marma points that promote relaxation and mental peace.',
      benefits: [
        'Reduces anxiety',
        'Lowers cortisol levels',
        'Promotes relaxation',
        'Improves mood',
        'Enhances sleep quality'
      ]
    },
    {
      id: 6,
      name: 'Foot Reflexology',
      category: 'therapy',
      image: '/foot massage.jpeg',
      duration: '60 min',
      price: 4500,
      description: 'Ancient pressure point therapy on feet corresponding to different organs and body systems.',
      longDescription: 'Based on the principle that specific points on the feet correspond to different organs and systems. Skilled pressure application helps restore balance and promote healing throughout the body.',
      benefits: [
        'Improves overall circulation',
        'Reduces foot pain',
        'Promotes deep relaxation',
        'Supports organ health',
        'Boosts energy levels'
      ]
    },
    {
      id: 7,
      name: 'Steam Bath / Steam Box Therapy',
      category: 'bath',
      image: '/steam bath.jpg',
      duration: '15 min',
      price: 3000,
      description: 'Quick herbal steam treatment to open pores and promote detoxification through sweating.',
      longDescription: 'A therapeutic steam treatment where you sit in a steam box infused with detoxifying herbs. The warm steam opens pores, promotes sweating, and helps eliminate toxins while relaxing muscles.',
      benefits: [
        'Opens and cleanses pores',
        'Eliminates toxins',
        'Relaxes muscles',
        'Improves circulation',
        'Boosts metabolism'
      ]
    },
    {
      id: 8,
      name: 'Herbal Bath',
      category: 'bath',
      image: '/hearbal bath.jpg',
      duration: '30 min',
      price: 4500,
      description: 'Soothing herbal bath with traditional Ayurvedic herbs for skin nourishment and relaxation.',
      longDescription: 'Immerse yourself in a warm bath infused with traditional Ayurvedic herbs and essential oils. The herbal properties are absorbed through skin while the warm water relaxes muscles and calms the mind.',
      benefits: [
        'Nourishes skin',
        'Relieves muscle soreness',
        'Calms nervous system',
        'Removes fatigue',
        'Promotes sound sleep'
      ]
    },
    {
      id: 9,
      name: 'Shirodhara',
      category: 'therapy',
      image: '/shirodhara.jpg',
      duration: '45 min',
      price: 12000,
      description: 'Ancient therapy where warm medicated oil is continuously poured on the forehead.',
      longDescription: 'A profound Ayurvedic treatment that involves gently pouring warm, medicated oil in a continuous stream across the forehead. This therapy works directly on the nervous system, calming the mind and promoting deep relaxation.',
      benefits: [
        'Calms mind and nervous system',
        'Improves sleep quality',
        'Reduces anxiety and stress',
        'Enhances mental clarity',
        'Balances hormones'
      ]
    },
    {
      id: 10,
      name: 'Full Body Scrub',
      category: 'bath',
      image: '/fullbodyscrub.jpg',
      duration: '45 min',
      price: 5000,
      description: 'Exfoliating treatment with herbal paste to remove dead skin and rejuvenate the body.',
      longDescription: 'A revitalizing treatment using a fine paste of herbs, grains, and natural ingredients to gently exfoliate and polish the skin. Removes dead skin cells, improves texture, and leaves skin glowing.',
      benefits: [
        'Removes dead skin cells',
        'Improves skin texture',
        'Enhances blood flow',
        'Detoxifies the body',
        'Leaves skin soft and glowing'
      ]
    }
  ];

  // Filter treatments
  const filteredTreatments = activeFilter === 'all' 
    ? treatments 
    : treatments.filter(t => t.category === activeFilter);

  // Loading effect
  useEffect(() => {
    setTimeout(() => setIsLoading(false), 1000);
  }, []);

  return (
    <div className="treatments-container">
      


      {/* Hero Section with banner.png from public folder - USING INLINE STYLE WITH PUBLIC PATH */}
      <section 
        className="treatments-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(46,125,50,0.9), rgba(0,0,0,0.7)), url('/footer banner.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1 className="hero-title">
            Ayurvedic <span>Treatments</span>
          </h1>
          <p className="hero-description">
            Ancient healing therapies for modern wellness
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="treatments-content">
        
        {/* Filter Section */}
        <div className="filter-wrapper">
          <div className="filter-container">
            <h2 className="section-title">Our Treatments</h2>
            <div className="filter-tabs">
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`filter-tab ${activeFilter === category.id ? 'active' : ''}`}
                  onClick={() => setActiveFilter(category.id)}
                >
                  <i className={category.icon}></i>
                  <span>{category.name}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Treatments Grid */}
        <section className="treatments-grid-section">
          <div className="treatments-grid">
            {filteredTreatments.map((treatment) => (
              <div
                key={treatment.id}
                className="treatment-card"
                onClick={() => setSelectedTreatment(treatment)}
              >
                <div className="card-media">
                  <img src={treatment.image} alt={treatment.name} />
                  <span className="duration-badge">{treatment.duration}</span>
                </div>

                <div className="card-content">
                  <h3 className="card-title">{treatment.name}</h3>
                  <p className="card-description">{treatment.description}</p>

                  <div className="card-footer">
                    <div className="price">
                      <span className="currency">Rs. </span>
                      <span className="amount">{treatment.price}</span>
                    </div>
                    <button className="view-btn">View Details</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="cta-container">
            <h2>Ready to Begin Your Healing Journey?</h2>
            <p>Book your personalized Ayurvedic treatment today</p>
            <button className="cta-button" onClick={() => navigate('/booking')}>
              Book Appointment
            </button>
          </div>
        </section>
      </div>

      {/* Treatment Modal */}
      {selectedTreatment && (
        <div className="treatment-modal" onClick={() => setSelectedTreatment(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedTreatment(null)}>×</button>
            
            <div className="modal-grid">
              <div className="modal-image">
                <img src={selectedTreatment.image} alt={selectedTreatment.name} />
              </div>

              <div className="modal-details">
                <span className="modal-category">{selectedTreatment.category}</span>
                <h2>{selectedTreatment.name}</h2>
                
                <div className="modal-meta">
                  <span className="modal-duration">
                    <i className="far fa-clock"></i> {selectedTreatment.duration}
                  </span>
                  <span className="modal-price">
                    <i className="fas fa-tag"></i> Rs. {selectedTreatment.price}
                  </span>
                </div>

                <p className="modal-description">{selectedTreatment.longDescription}</p>

                <h3>Benefits</h3>
                <ul className="modal-benefits">
                  {selectedTreatment.benefits.map((benefit, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i> {benefit}
                    </li>
                  ))}
                </ul>

                <button className="modal-book-btn" onClick={() => navigate('/booking')}>
                  Book This Treatment
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Treatments;